import flashesInfo from './flashesInfo';

export default flashesInfo;
